<template>
  <div>
    <center>
      <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
      <h1>Watchlist</h1>
      <p>Click on incident to view details</p>
    </center>
    <hr>
    <v-btn @click="getWatchlistData()" class="ma-2" color="primary" text ><v-icon darkleft>mdi-refresh</v-icon>REFRESH</v-btn>
    <div v-for="incident in incidents" v-bind:key="incident.incidentID" class="watchlistItems">
        <router-link style="text-decoration: none; color: inherit;" :to="{path: 'incident', query: {incidentID: incident.incidentID}}">
        <h2>{{ incident.type }}</h2>
        <p>{{ incident.address }}</p>
        <p>{{ incident.municipality }}</p>
        <p>{{ incident.date_created + ' - ' +incident.time_created }}</p>
      </router-link>
      <hr>
    </div>
    <div id="nullWatchlist" v-if="emptyWatchlist">
      <center>
        <h2 id="thankYouMsg">Thank you for creating an account with Fire Watch 101!</h2>
        <h3 id="nullWatchlistMsg1">This page is your watchlist. </h3>
        <h3 id="nullWatchlistMsg2">Using the menu, navigate to the watchlist manager to manage which incidents show up here</h3>
      </center>
    </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { set } from 'vue/types/umd';
export default {
  data: () => ({
    incidents: [],
    loading: false,
    emptyWatchlist: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    this.getWatchlistData();
    window.scrollTo(0,0);
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async getWatchlistData(){
      this.loading = true;
      const response = await fetch(localStorage.apiURL + "/app/watchlist", {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
      });

      if (!response.ok){
        if (response.status == 401){
          localStorage.removeItem('username');
          this.$router.push('login')
        }
        this.loading = false;
        this.error("API returned " + response.status);
        return
      }

      let data = await response.json();

      if (!data.success){
        this.error(data.msg);
        return
      }
      this.incidents = null;
      this.incidents = data["watchlist-incidents"];
      this.loading = false
      if (this.incidents.length == 0){
        this.emptyWatchlist = true
      }
      window.scrollTo(0,0);
    },
  registerFirebase(){
      
 
    },
  },
};
</script>

<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}

p{
  margin: 0;
}

#nullWatchlist{
  margin-top: 7%;
}

#nullWatchlistMsg1{
  margin-top: 100px;
}
</style>
